var c = {};

var shared = require('shared');
for (var name in shared) {
    c[name] = shared[name];
}

/* jshint ignore:start */
var _locale = require('./dateTime/locale');
var _toLocaleString = Number.prototype.toLocaleString;

Number.prototype.toLocaleString = function(loc, options) {
    loc = loc || _locale;
    return _toLocaleString.call(this, loc, options);
}
/* jshint ignore:end */

HTMLElement.prototype.add = HTMLElement.prototype.appendChild;
HTMLElement.prototype.remove = HTMLElement.prototype.removeChild;

c.animation = require('./animation');
c.authRequestSender = require('./messaging/authRequestSender');
c.blurEventListener = require('./blurEventListener');
c.buttonMediumPresenter = require('./buttonMediumPresenter');
c.buttonPresenter = require('./buttonPresenter');
c.changeEventListener = require('./changeEventListener');
c.classManipulator = require('./classManipulator');
c.clickableCollapsibleDivPresenter = require('./clickableCollapsibleDivPresenter');
c.clickEventListener = require('./clickEventListener');
c.clickEventListener = require('./clickEventListener');
c.clone = require('./clone');
c.cloneArray = require('./cloneArray');
c.collapsibleDivPresenter = require('./collapsibleDivPresenter');
c.copyPropertiesInto = require('./copyPropertiesInto');
c.createDataUri = require('./createDataUri');
c.deactivate = require('./deactivate');
c.document = require('./document');
c.emitEvent = require('./emitEvent');
c.emptyPresenter = require('./emptyPresenter');
c.extend = require('./extend');
c.fetch = require('./fetch');
c.fieldErrorPresenter = require('./fieldErrorPresenter');
c.focusEventListener = require('./focusEventListener');
c.formatDateTime = require('./formatDateTime');
c.formatNumber = require('./formatNumber');
c.formPresenter = require('./formPresenter');
c.getErrorMessage = require('./getErrorMessage');
c.getGeometryOfElement = require('./getGeometryOfElement');
c.glyphIconInputPresenter = require('./glyphIconInputPresenter');
c.glyphIconPresenter = require('./glyphIconPresenter');
c.hashQueryBuilder = require('./hashQueryBuilder');
c.iContains = require('./iContains');
c.imagePresenter = require('./imagePresenter');
c.inlineFormPresenter = require('./inlineFormPresenter');
c.inputEventListener = require('./inputEventListener');
c.inputPresenter = require('./inputPresenter');
c.jquery = require('jquery');
c.keyDownEventListener = require('./keyDownEventListener');
c.keyupEventListener = require('./keyupEventListener');
c.listGroupPresenter = require('./listGroupPresenter');
c.loginRequestSender = require('./messaging/loginRequestSender');
c.mimeType = require('./mimeType');
c.modalConfirmationPresenter = require('./modalConfirmationPresenter');
c.modalImagePresenter = require('./modalImagePresenter');
c.modalPresenter = require('./modalPresenter');
c.modelCollection = require('./modelCollection');
c.modelProperty = require('./modelProperty');
c.modelToDto = require('./modelToDto');
c.negotiateCssClass = require('./negotiateCssClass');
c.negotiateReadOnly = require('./negotiateReadOnly');
c.object = require('./newObject');
c.openTab = require('./openTab');
c.prompt = require('./prompt');
c.publicRequestSender = require('./messaging/publicRequestSender');
c.queryBuilder = require('./queryBuilder');
c.queryParser = require('./queryParser');
c.readOnlyModelCollection = require('./readOnlyModelCollection');
c.readOnlyModelProperty = require('./readOnlyModelProperty');
c.region = require('./region');
c.request = require('./request');
c.requestBatchSender = require('./messaging/requestSender');
c.scrollTo = require('./scrollTo');
c.sendRequest = require('./sendRequest');
c.serializedRequestSender = require('./messaging/serializedRequestSender');
// c.settings = require('settings');
c.setViewData = require('./viewTools/setViewData');
c.submitEventListener = require('./submitEventListener');
c.textInputPresenter = require('./textInputPresenter');
c.unauthorized = require('./messaging/unauthorized');
c.validateModel = require('./newValidateModel');
c.validators = require('./validators');
c.window = require('./window');

c.button = c.buttonPresenter;
c.clickableCollapsibleDiv = c.clickableCollapsibleDivPresenter;
c.collapsibleDiv = c.collapsibleDivPresenter;
c.form = c.formPresenter;
c.glyphIcon = c.glyphIconPresenter;
c.image = c.imagePresenter;
c.inlineForm = c.inlineFormPresenter;
c.input = c.inputPresenter;
c.mediumButtonPresenter = c.buttonMediumPresenter;
c.modal = c.modalPresenter;
c.requestSender = c.requestBatchSender;
c.textInput = c.textInputPresenter;

c.localStorage = c.window.localStorage;

module.exports = c;
